// frontend/src/components/layout/LanguageSwitcher.tsx

import { useTranslation } from 'react-i18next';
import { Globe } from 'lucide-react';

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const languages = [
    { code: 'en', name: 'English', flag: '🇺🇸' },
    { code: 'pt-BR', name: 'Português', flag: '🇧🇷' },
    { code: 'es-LA', name: 'Español', flag: '🇲🇽' },
  ];

  const currentLanguage = languages.find(lang => lang.code === i18n.language) || languages[0];

  return (
    <div className="relative group">
      <button className="flex items-center gap-2 px-3 py-2 rounded-apple hover:bg-apple-gray-100 transition">
        <Globe className="w-4 h-4" />
        <span className="hidden lg:inline">{currentLanguage.flag}</span>
      </button>

      {/* Dropdown */}
      <div className="absolute right-0 mt-2 w-48 bg-white rounded-apple-lg shadow-apple-lg border border-apple-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
        {languages.map((lang) => (
          <button
            key={lang.code}
            onClick={() => i18n.changeLanguage(lang.code)}
            className={`w-full px-4 py-2 text-left hover:bg-apple-gray-50 first:rounded-t-apple-lg last:rounded-b-apple-lg transition ${
              i18n.language === lang.code ? 'bg-apple-blue-50 text-apple-blue-600' : ''
            }`}
          >
            <span className="mr-2">{lang.flag}</span>
            {lang.name}
          </button>
        ))}
      </div>
    </div>
  );
}
